"use client";

import React from "react";
import FadeIn from "../ui/FadeIn";
import Input from "../ui/Input";
import Textarea from "../ui/Textarea";
import Button from "../ui/Button";

interface ContactProps {
  title?: string;
  bgWhite?: boolean;
}

export default function Contact({
  title = "Please feel free to contact us, if you would like to about our tour services.",
  bgWhite = false,
}: ContactProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <section
      className={`flex text-center px-4 py-16 md:py-24 ${
        bgWhite ? "bg-white" : "bg-[#F6F7F9]"
      }`}
    >
      <div className="mx-auto max-w-6xl">
        <FadeIn direction="up">
          <h2 className="mx-auto max-w-3xl text-center text-3xl font-semibold leading-[1.2] tracking-tight text-[#0A2B1C] md:text-5xl">
            {title}
          </h2>
        </FadeIn>

        <FadeIn
          direction="up"
          delay={0.2}
          className="mt-12 flex justify-center"
        >
          <form
            className="flex max-w-[600px] w-full flex-col gap-6"
            onSubmit={handleSubmit}
          >
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              <Input type="text" placeholder="Full Name" required />
              <Input type="email" placeholder="Email" required />
            </div>
            <Input type="text" placeholder="Subject" required />
            <Textarea placeholder="Question" rows={4} required />

            <div className="mt-2 flex justify-start">
              <Button
                type="submit"
                variant="secondary"
                size="sm"
                className="bg-[#00426B] px-8 py-1 text-[14px] font-semibold text-accent! shadow-lg transition-all hover:bg-[#003255]"
              >
                Send Inquiry
              </Button>
            </div>
          </form>
        </FadeIn>
      </div>
    </section>
  );
}
